<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <ng-container *ngIf="showLegacy; then legacyModelTemplate else regulationModelTemplate">
        </ng-container>
        <ng-template #legacyModelTemplate>
          <tbody>
            <tr>
              <td class="no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>EUDAMED DI</th>
                      <th>EUDAMED DI Issuing Agency</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Eudamed DI')">
                        <label controlName="eudamedDi"></label>
                      </td>
                      <td [ngClass]="isDefault('Eudamed DI Issuing Agency')"><label controlName="eudamedDiIssuingAgency"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>EUDAMED ID Issuing Agency</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Eudamed ID Issuing Agency')"><label controlName="eudamedIdIssuingAgency"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="col-sm-6 no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Device Model</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Device Model')"><label controlName="deviceModel"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Applicable Legislation</th>
                      <th>Device Risk Class</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Applicable Legislation')">
                        <label controlName="applicableLegislation"></label>
                      </td>
                      <td [ngClass]="isDefault('Device Risk Class')"><label controlName="deviceRiskClass"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Manufacturer SRN</th>
                      <th>Manufacturer CHRN</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Manufacturer SRN')">
                        <label controlName="manufacturerSRN"></label>
                      </td>
                      <td [ngClass]="isDefault('Manufacturer CHRN')">
                        <label controlName="manufacturerChrn"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Device Name</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Device Name')"><label controlName="deviceName"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td *ngIf="itemDetails" class="col-sm-6 no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Multi-Component Device Type</th>
                      <th>Special Device Type</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Multi-Component Device Type')">
                        <label controlName="multiComponentDeviceType"></label>
                      </td>
                      <td [ngClass]="isDefault('Special Device Type')">
                        <label controlName="specialDeviceType"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Authorized Representative SRN</th>
                      <th>Authorized Representative CHRN</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Authorized Representative SRN')">
                        <label controlName="authRepSRN"></label>
                      </td>
                      <td [ngClass]="isDefault('Authorized Representative CHRN')">
                        <label controlName="authorizedRepChrn"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </ng-template>
        <ng-template #regulationModelTemplate>
          <tbody>
            <tr>
              <td class="no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Basic UDI-DI</th>
                      <th>Issuing Agency</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('BUDI-DI')">
                        <label controlName="budi"></label>
                      </td>
                      <td [ngClass]="isDefault('BUDI-DI Issuing Agency')"><label controlName="bAgency"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Applicable Legislation</th>
                      <th>Device Risk Class</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Applicable Legislation')">
                        <label controlName="applicableLegislation"></label>
                      </td>
                      <td [ngClass]="isDefault('Device Risk Class')"><label controlName="deviceRiskClass"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="col-sm-6 no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Device Model</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Device Model')"><label controlName="deviceModel"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-right-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Device Name</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Device Name')"><label controlName="deviceName"></label></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Manufacturer SRN</th>
                      <th>Manufacturer CHRN</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Manufacturer SRN')">
                        <label controlName="manufacturerSRN"></label>
                      </td>
                      <td [ngClass]="isDefault('Manufacturer CHRN')">
                        <label controlName="manufacturerChrn"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td class="col-sm-6 no-right-padding">

                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Multi-Component Device Type</th>
                      <th>Special Device Type</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Multi-Component Device Type')">
                        <label controlName="multiComponentDeviceType"></label>
                      </td>
                      <td [ngClass]="isDefault('Special Device Type')">
                        <label controlName="specialDeviceType"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr *ngIf="itemDetails">
              <td class="no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>System or Procedure Pack Producer SRN</th>
                      <th>System or Procedure Pack Producer CHRN</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('System or Procedure Pack Producer SRN')"> <label controlName="sppProducerSRN"></label>
                      </td>
                      <td [ngClass]="isDefault('System or Procedure Pack Producer CHRN')"> <label controlName="systemProcedurePackChrn"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td class="col-md-12 no-right-padding">

                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>System or Procedure Pack Type</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('SPPType')"><label controlName="sppType"></label></td>
                    </tr>
                  </tbody>
                </table>

              </td>
            </tr>
            <tr>
              <td class="no-left-padding">
                <table class="table table-inner table-condensed">
                  <tbody>
                    <tr>
                      <th>Authorized Representative SRN</th>
                      <th>Authorized Representative CHRN</th>
                    </tr>
                    <tr>
                      <td [ngClass]="isDefault('Authorized Representative SRN')">
                        <label controlName="authRepSRN"></label>
                      </td>
                      <td [ngClass]="isDefault('Authorized Representative CHRN')">
                        <label controlName="authorizedRepChrn"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </form>
  </div>
</div>
